import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  SystemSnapshotApiModel,
  SystemMetricsApiModel,
  ProgramsByTypeApiModel,
  AgenciesActivitySearchQuery,
  AgenciesActivityApiModel
} from '@app/api/api-models/system-administration';
import { CustomUtils } from '@app/shared/utils/custom-utils';
import { toQueryParams } from '@app/shared/utils';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class SystemAdministrationDashboardService {
  public apiUrl = 'system-dashboard';

  constructor(private readonly http: HttpClientService) {}

  public getSystemSnapshot(startDate: Date, endDate: Date): Observable<SystemSnapshotApiModel> {
    const startDateString = CustomUtils.getShortDateString(startDate);
    const endDateString = CustomUtils.getShortDateString(endDate);

    return this.http.get<SystemSnapshotApiModel>(`${this.apiUrl}/snapshot`, {
      params: { startDate: startDateString, endDate: endDateString }
    });
  }

  public getSystemMetrics(): Observable<SystemMetricsApiModel> {
    return this.http.get<SystemMetricsApiModel>(`${this.apiUrl}/metrics`);
  }

  public getProgramsByType(): Observable<ProgramsByTypeApiModel> {
    return this.http
      .get<ProgramsByTypeApiModel>(`${this.apiUrl}/programs-by-type`)
      .pipe(map((response) => new ProgramsByTypeApiModel().deserialize(response)));
  }

  public getAgenciesActivity(searchQuery: AgenciesActivitySearchQuery): Observable<AgenciesActivityApiModel> {
    return this.http.get<AgenciesActivityApiModel>(`${this.apiUrl}/sites`, { params: toQueryParams(searchQuery) });
  }
}
